import { styled } from '@/stitches.config';
import { Box, TableCell, TableRow } from '@base-app';

export const StyledTableCell = styled(TableCell, {
  maxWidth: '200px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const TeamsListDesktopStyled = styled(Box, {
  '@xs': {
    display: 'none',
  },
  '@sm': {
    display: 'block',
  },
});

export const TableCellActionsStyled = styled(TableCell, {
  width: '$8',
});

export const TableRowStyled = styled(TableRow, {
  '& td': {
    lineHeight: '$8',
  },
});
